// ai-config.ts — proxy URL derivation + aiAvailable gate.
// Keeps all "should AI run?" logic in one place so features never need to
// inspect auth/network/pref themselves.

import type { LifeOsApi } from "../life-os-contract";
import { isAiEnabled } from "./ai-prefs";

/**
 * Returns the full URL of the Supabase Edge Function proxy.
 * Derived from VITE_SUPABASE_URL at build time — no secret here.
 */
export function getProxyUrl(): string {
  const base = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  return `${base ?? ""}/functions/v1/ai`;
}

/**
 * True only when ALL of:
 *   1. User has opted in (AI enabled in Settings)
 *   2. A Supabase session exists (auth.user != null)
 *   3. Browser is online
 *
 * Every AI feature checks this before calling the proxy.
 * Offline / signed-out / disabled → false → no network calls.
 */
export function aiAvailable(api: LifeOsApi): boolean {
  return isAiEnabled() && api.auth.user !== null && navigator.onLine;
}
